'use strict';

module.exports = require('./Holidays');